import mitt from 'mitt'

export interface SpaceCarouselPayload {
	index?: number
	type?: string
}

export type DialogsEvents = {
	'spaceCarousel.open'?: SpaceCarouselPayload
	'spaceCarousel.close'?: never
}

export const dialogsEmitter = mitt<DialogsEvents>()
